module.exports = __webpack_public_path__ + "static/vf-button-men-bag.6d6e3f0b.svg";